"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SecurityLockIcon = function SecurityLockIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      opacity: "0.1",
      d: "M32.0001 58.3636C46.5603 58.3636 58.3637 46.5602 58.3637 32C58.3637 17.4398 46.5603 5.63636 32.0001 5.63636C17.4399 5.63636 5.63647 17.4398 5.63647 32C5.63647 46.5602 17.4399 58.3636 32.0001 58.3636Z",
      fill: "#6E0AD6",
      stroke: "#6E0AD6",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M28.0177 21.1911L28.7673 26.5251L24.3989 27.1391L23.5717 21.2533C23.5717 21.2533 22.2248 10.0011 33.1228 8.46949C44.0207 6.93788 45.9346 17.2194 45.9346 17.2194L46.8911 24.0249L42.4767 24.6453L41.5332 17.9318C41.5332 17.9318 40.1017 12.084 34.078 12.9306C28.0542 13.7772 27.8382 19.2469 28.0177 21.1911Z",
      fill: "#6E0AD6"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M25.7952 25.3955L25.9955 26.8209",
      stroke: "#4a4a4a",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M47.3684 23.7783L23.5805 27.1215C18.9224 27.7761 17.2296 30.9557 17.7364 34.5616L19.9092 50.022C20.4097 53.5828 23.7915 55.8575 27.545 55.33L51.3329 51.9868C55.0395 51.4659 57.8926 49.6385 56.7435 44.8453L54.5707 29.3849C53.9534 24.9924 52.2597 23.0909 47.3684 23.7783ZM39.5527 39.9989C39.4715 40.1023 39.3903 40.2056 39.4093 40.3408L39.9541 44.2172C40.0808 45.1187 39.4378 45.9904 38.4525 46.1289L37.8895 46.208C36.9511 46.3399 36.0521 45.7308 35.9191 44.7843L35.3743 40.9079C35.3553 40.7727 35.2957 40.6891 35.1423 40.6188C33.4077 39.8513 32.4252 37.967 33.01 36.0003C33.3741 34.846 34.2859 33.8445 35.4741 33.4477C37.9786 32.5441 40.5437 34.1141 40.8795 36.503C41.0632 37.8102 40.5304 39.1261 39.5527 39.9989Z",
      fill: "white"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M19.1403 29.4256C19.8847 28.3831 21.0882 27.6044 22.4677 27.4105L48.8619 23.701C51.5749 23.3198 54.0923 25.2167 54.4736 27.9297L57.0392 46.185C57.4205 48.898 55.5235 51.4154 52.8105 51.7967L27.5659 55.3446",
      stroke: "#4a4a4a",
      strokeWidth: "1",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M46.9306 23.9725L46.0711 17.8567C45.1987 11.649 39.4297 7.30177 33.222 8.1742C27.0143 9.04664 22.621 14.8221 23.4935 21.0298L24.353 27.1455L28.8593 26.5122L27.9998 20.3965C27.4699 16.6259 30.0782 13.1645 33.8488 12.6346C37.6194 12.1046 41.0808 14.713 41.6108 18.4836L42.4703 24.5993",
      stroke: "#4a4a4a",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M38.2906 46.2409C37.3709 46.3702 36.4858 45.7443 36.3501 44.7787L35.7943 40.8241C35.7749 40.6862 35.716 40.6007 35.5652 40.5281C33.8596 39.7362 32.8855 37.8099 33.4482 35.8082C33.7989 34.6336 34.6878 33.6177 35.851 33.2198C38.3025 32.3125 40.8271 33.9272 41.1696 36.3643C41.357 37.6978 40.8418 39.0362 39.8416 39.9271C39.7625 40.032 39.6835 40.1369 39.7029 40.2748L40.2587 44.2293C40.3879 45.149 39.762 46.0341 38.7964 46.1698L38.2906 46.2409Z",
      stroke: "#4a4a4a",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M18.272 32.9237C18.272 32.9237 13.8486 37.4843 9.66419 38.0724L11.0407 47.8667C11.325 49.89 12.4112 51.613 13.9854 52.4703C15.5595 53.3275 20.335 55.6105 20.5318 55.6766L21.5355 56.1452L22.3712 55.4181C22.5357 55.2543 26.5034 51.7895 27.8198 50.4791C29.0571 49.2736 29.6723 47.3115 29.3815 45.2422L28.0114 35.4938C23.781 36.0884 18.272 32.9237 18.272 32.9237Z",
      fill: "#6E0AD6",
      stroke: "#4A4A4A",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M16.0588 44.5356L19.5662 47.1375L23.8344 41.4734",
      stroke: "white",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M28.1491 12.4509C25.885 14.6916 24.7611 18.0382 25.2587 21.5789L25.5753 23.832",
      stroke: "white",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M52.106 32.1463L53.5476 42.404",
      stroke: "#4A4A4A",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M53.9407 45.2015L54.2028 47.0665",
      stroke: "#4A4A4A",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
};
SecurityLockIcon.propTypes = {
  color: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
SecurityLockIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = exports["default"] = SecurityLockIcon;